module.exports = __webpack_public_path__ + "img/ca-3.e7c08dff.jpg";